import PassageUnderlineUI from "./PassageUnderlineUI";

import "./passageUnderline.css";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class PassageUnderline extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "PassageUnderline";
  }

  static get requires() {
    return [PassageUnderlineUI];
  }
}
